export const bill_generate_type_lists = [
    {
        label: '无需提供账单',
        value: 'no_need'
    },
    {
        label: '需要提供账单',
        value: 'self_submit'
    },
    {
        label: '付款生成账单',
        value: 'expense_group'
    },
    {
        label: '合同生成账单',
        value: 'contract'
    }
]

export const bill_provider_types = [
    {
        label: '财务协助',
        value: 'financial'
    },
    {
        label: '系统生成',
        value: 'system'
    },
    {
        label: '合同负责人',
        value: 'personal'
    },
]